var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "header" }, [
        _c("img", {
          staticClass: "header-menu",
          attrs: { src: require("@/assets/icons/icon_menu.png") },
          on: { click: _vm.onClickMenu }
        }),
        _c("img", {
          staticClass: "header-bluetooth",
          attrs: {
            src: _vm.isConnected
              ? require("@/assets/icons/icon_bluetooth.png")
              : require("@/assets/icons/icon_bluetooth_disconnected.png")
          },
          on: { click: _vm.onClickDisconnectDevice }
        }),
        _c("img", {
          staticStyle: { width: "105px", height: "41px" },
          attrs: { src: require("@/assets/logo/logo.png") }
        })
      ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "model-setting" }, [
          _c(
            "div",
            { ref: "modelSelect", staticClass: "model-select" },
            [
              _vm._l(_vm.modelList.slice(0, 6), function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "model-item",
                    class: _vm.curveModel === index ? "model-item-active" : "",
                    on: {
                      click: function($event) {
                        return _vm.onClickModelItem(index)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(item.modeName) + "\n          "
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "model-button",
                        class:
                          _vm.curveModel === index ? "model-button-active" : ""
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.curveModel === index ? "Used" : "Use") +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              }),
              _c("div", { staticClass: "model-mask" })
            ],
            2
          ),
          _c("img", {
            staticClass: "setting",
            attrs: { src: require("@/assets/icons/icon_setting.png") },
            on: { click: _vm.onClickSetting }
          })
        ]),
        _c("div", { staticClass: "content-main" }, [
          _c(
            "div",
            { staticClass: "main-header" },
            [
              _c("span", [_vm._v(_vm._s(_vm.curveTitle))]),
              _c(
                "van-button",
                {
                  staticClass: "main-header-save",
                  attrs: { type: "default", disabled: _vm.saveDisabled },
                  on: { click: _vm.onClickSave }
                },
                [_vm._v("Save\n        ")]
              )
            ],
            1
          ),
          _vm.isSupportSwitchMode
            ? _c(
                "div",
                { staticStyle: { "font-size": "16px", margin: "10px 0" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v("\n          Output Mode：\n        ")]
                  ),
                  _c(
                    "van-radio-group",
                    {
                      attrs: { direction: "horizontal" },
                      on: { change: _vm.onOutputTypeChange },
                      model: {
                        value: _vm.outputType,
                        callback: function($$v) {
                          _vm.outputType = $$v
                        },
                        expression: "outputType"
                      }
                    },
                    [
                      _c(
                        "van-radio",
                        { attrs: { name: 0x10, "checked-color": "#8866f5" } },
                        [_vm._v("Voltage")]
                      ),
                      !_vm.supportTripleCartridge
                        ? _c(
                            "van-radio",
                            {
                              attrs: { name: 0x20, "checked-color": "#8866f5" }
                            },
                            [_vm._v("Power\n          ")]
                          )
                        : _vm._e(),
                      _c(
                        "van-radio",
                        { attrs: { name: 0x40, "checked-color": "#8866f5" } },
                        [_vm._v("Temperature\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.supportDoubleCartridge
            ? _c("div", [
                _vm.outputType !== 0x40
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "bold"
                        }
                      },
                      [_vm._v("\n          Cartridge Mode:\n        ")]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "double-cartridge" },
                  [
                    _vm.outputType === 0x10 ||
                    _vm.outputType === 0x20 ||
                    _vm.outputType === 0
                      ? _c(
                          "van-radio-group",
                          {
                            attrs: { direction: "horizontal" },
                            on: { change: _vm.onDoubleCartridgeModeChange },
                            model: {
                              value: _vm.doubleCartridgeMode,
                              callback: function($$v) {
                                _vm.doubleCartridgeMode = $$v
                              },
                              expression: "doubleCartridgeMode"
                            }
                          },
                          [
                            _c(
                              "van-radio",
                              {
                                attrs: { name: 0, "checked-color": "#8866f5" }
                              },
                              [_vm._v("Left")]
                            ),
                            _c(
                              "van-radio",
                              {
                                attrs: { name: 1, "checked-color": "#8866f5" }
                              },
                              [_vm._v("Right")]
                            ),
                            _c(
                              "van-radio",
                              {
                                attrs: { name: 2, "checked-color": "#8866f5" }
                              },
                              [_vm._v("Double")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.supportTripleCartridge
            ? _c("div", [
                _vm.outputType !== 0x40
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "bold"
                        }
                      },
                      [_vm._v("\n          Cartridge Mode:\n        ")]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "double-cartridge" },
                  [
                    _vm.outputType === 0x10 ||
                    _vm.outputType === 0x20 ||
                    _vm.outputType === 0
                      ? _c(
                          "van-radio-group",
                          {
                            attrs: { direction: "horizontal" },
                            on: { change: _vm.onTripleCartridgeModeChange },
                            model: {
                              value: _vm.tripleCartridgeMode,
                              callback: function($$v) {
                                _vm.tripleCartridgeMode = $$v
                              },
                              expression: "tripleCartridgeMode"
                            }
                          },
                          [
                            _c(
                              "van-radio",
                              {
                                attrs: { name: 0, "checked-color": "#8866f5" }
                              },
                              [_vm._v("Single")]
                            ),
                            _c(
                              "van-radio",
                              {
                                attrs: { name: 1, "checked-color": "#8866f5" }
                              },
                              [_vm._v("Double")]
                            ),
                            _c(
                              "van-radio",
                              {
                                attrs: { name: 2, "checked-color": "#8866f5" }
                              },
                              [_vm._v("Triple")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.outputType === 0 ||
          _vm.outputType === 0x10 ||
          _vm.outputType === 0x20
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "voltage-one" },
                  _vm._l(
                    _vm.modelList[_vm.curveModel].diyVoltage.slice(
                      0,
                      _vm.voltageCount
                    ),
                    function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "voltage-number" },
                        [
                          _vm.outputType === 0x20
                            ? _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(Math.abs(item / 100).toFixed(1)) +
                                    _vm._s(_vm.unitName) +
                                    "\n            "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(Math.abs(item / 1000).toFixed(1)) +
                                    _vm._s(_vm.unitName) +
                                    "\n            "
                                )
                              ])
                        ]
                      )
                    }
                  ),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "voltage-ctrl" },
                  _vm._l(
                    _vm.modelList[_vm.curveModel].diyVoltage.slice(
                      0,
                      _vm.voltageCount
                    ),
                    function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "voltage-number" },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "font-weight": "bold",
                                "line-height": "30px"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.stepVoltageOrPower("add", index)
                                }
                              }
                            },
                            [_vm._v("\n             +\n            ")]
                          )
                        ]
                      )
                    }
                  ),
                  0
                ),
                _c(
                  "div",
                  {
                    staticClass: "voltage-two",
                    staticStyle: { width: "100%", height: "calc(18vh)" },
                    attrs: { id: "voltageTwo" },
                    on: {
                      touchmove: function($event) {
                        $event.preventDefault()
                        return _vm.onTouchmoveVoltage.apply(null, arguments)
                      }
                    }
                  },
                  _vm._l(
                    _vm.modelList[_vm.curveModel].diyVoltage.slice(
                      0,
                      _vm.voltageCount
                    ),
                    function(value, index) {
                      return _c("van-slider", {
                        key: index,
                        attrs: {
                          vertical: "",
                          min: _vm.dragValue.max,
                          max: _vm.dragValue.min,
                          step: _vm.dragValue.step,
                          "bar-height": "4px",
                          "active-color": "#EEEEEE",
                          "inactive-color": "#6649C4"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChangeVoltageCurve(index)
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button",
                              fn: function() {
                                return [
                                  _c("img", {
                                    staticClass: "slider-button",
                                    attrs: {
                                      src: require("@/assets/icons/icon_slider_button.png")
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.modelList[0].diyVoltage[index],
                          callback: function($$v) {
                            _vm.$set(_vm.modelList[0].diyVoltage, index, $$v)
                          },
                          expression: "modelList[0].diyVoltage[index]"
                        }
                      })
                    }
                  ),
                  1
                ),
                _c(
                  "div",
                  { staticClass: "voltage-ctrl" },
                  _vm._l(
                    _vm.modelList[_vm.curveModel].diyVoltage.slice(
                      0,
                      _vm.voltageCount
                    ),
                    function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "voltage-number" },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "font-weight": "bold",
                                height: "20px"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.stepVoltageOrPower("sub", index)
                                }
                              }
                            },
                            [_vm._v("\n             -\n            ")]
                          )
                        ]
                      )
                    }
                  ),
                  0
                ),
                false
                  ? _c(
                      "div",
                      { staticClass: "voltage-three" },
                      _vm._l(6, function(index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "voltage-number" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  ((_vm.outputDuration / 1000) * index).toFixed(
                                    2
                                  )
                                ) +
                                "s\n          "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                false
                  ? _c("div", { staticClass: "description" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.modelList[0].heatingRemarks) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                _c("div", { staticStyle: { "margin-top": "24px" } }, [
                  _vm.supportLevel
                    ? _c(
                        "div",
                        { staticClass: "device-level" },
                        [
                          _vm._v("\n            Curve：\n            "),
                          _c(
                            "van-dropdown-menu",
                            [
                              _c(
                                "van-dropdown-item",
                                {
                                  ref: "item",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "title",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "drop-item-level"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.currentDeviceLevelItem
                                                        .text
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2236818737
                                  )
                                },
                                [
                                  _vm._l(_vm.deviceLevelList, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "drop-item-level__wrap",
                                        on: {
                                          click: function($event) {
                                            return _vm.onLevelDropdown(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "drop-item-level__content",
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "justify-content": "center"
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(item.text))
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "control" }, [
                    false
                      ? _c(
                          "div",
                          {
                            staticClass: "control-left",
                            style: {
                              color: _vm.modelList[0].isSupportPreheat
                                ? "#6649C4"
                                : "#ddd"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "title" },
                              [
                                _vm._v(
                                  "\n                Preheat\n                "
                                ),
                                _c("van-switch", {
                                  staticClass: "preheat-switch",
                                  attrs: {
                                    "active-color": "#66DCA5",
                                    "inactive-color": "#D6CDF2",
                                    size: "20"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.onClickModelItem(0)
                                    }
                                  },
                                  model: {
                                    value: _vm.modelList[0].isSupportPreheat,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.modelList[0],
                                        "isSupportPreheat",
                                        $$v
                                      )
                                    },
                                    expression: "modelList[0].isSupportPreheat"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("div", { staticClass: "subtitle" }, [
                              _vm._v("\n                Times："),
                              _c(
                                "span",
                                {
                                  style: {
                                    color: _vm.modelList[0].isSupportPreheat
                                      ? "#6649C4"
                                      : "#ddd"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        _vm.modelList[0].preheatTime / 1000
                                      ).toFixed(1)
                                    ) + "s"
                                  )
                                ]
                              )
                            ]),
                            _c(
                              "div",
                              { staticClass: "times-item" },
                              [
                                _c("van-slider", {
                                  attrs: {
                                    min: "1000",
                                    max: "20000",
                                    step: 500,
                                    "bar-height": "4px",
                                    "active-color": "#6649C4",
                                    "inactive-color": "#FFFFFF",
                                    disabled: !_vm.modelList[0].isSupportPreheat
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.onClickModelItem(0)
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button",
                                        fn: function() {
                                          return [
                                            _c("img", {
                                              staticClass: "slider-button",
                                              attrs: {
                                                src: _vm.modelList[0]
                                                  .isSupportPreheat
                                                  ? require("@/assets/icons/icon_slider_button_vertical.png")
                                                  : require("@/assets/icons/icon_slider_button_vertical_disabled.png")
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3138514104
                                  ),
                                  model: {
                                    value: _vm.modelList[0].preheatTime,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.modelList[0],
                                        "preheatTime",
                                        $$v
                                      )
                                    },
                                    expression: "modelList[0].preheatTime"
                                  }
                                }),
                                _vm._m(0)
                              ],
                              1
                            ),
                            _c("div", { staticClass: "subtitle" }, [
                              _vm._v("\n                Voltage："),
                              _c(
                                "span",
                                {
                                  style: {
                                    color: _vm.modelList[0].isSupportPreheat
                                      ? "#6649C4"
                                      : "#ddd"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        _vm.modelList[0].preheatVoltage / 1000
                                      ).toFixed(1)
                                    ) + "v"
                                  )
                                ]
                              )
                            ]),
                            _c(
                              "div",
                              { staticClass: "voltage-item" },
                              [
                                _c("van-slider", {
                                  attrs: {
                                    min: "100",
                                    max: "4200",
                                    step: 100,
                                    "bar-height": "4px",
                                    "active-color": "#6649C4",
                                    "inactive-color": "#FFFFFF",
                                    disabled: !_vm.modelList[0].isSupportPreheat
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button",
                                        fn: function() {
                                          return [
                                            _c("img", {
                                              staticClass: "slider-button",
                                              attrs: {
                                                src: _vm.modelList[0]
                                                  .isSupportPreheat
                                                  ? require("@/assets/icons/icon_slider_button_vertical.png")
                                                  : require("@/assets/icons/icon_slider_button_vertical_disabled.png")
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3138514104
                                  ),
                                  model: {
                                    value: _vm.modelList[0].preheatVoltage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.modelList[0],
                                        "preheatVoltage",
                                        $$v
                                      )
                                    },
                                    expression: "modelList[0].preheatVoltage"
                                  }
                                }),
                                _vm._m(1)
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.supportCustomOutputDuration &&
                    [0, 0x10, 0x20].includes(_vm.outputType)
                      ? _c(
                          "div",
                          {
                            staticClass: "control-right",
                            style: {
                              // visibility: supportOutputDuration ? 'visible' : 'hidden',
                              color: _vm.enableCtrlFunc ? "#6649C4" : "#ddd"
                            }
                          },
                          [
                            false
                              ? _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    "\n                NFC Settings\n              "
                                  )
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "title",
                                style: {
                                  color: _vm.disabledCtrlFuncUI
                                    ? "#ddd"
                                    : "#6649C4"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Output Duration\n              "
                                )
                              ]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.outputDurationValue,
                                  expression: "outputDurationValue"
                                }
                              ],
                              staticStyle: { "margin-top": "10px" },
                              attrs: {
                                disabled: _vm.disabledCtrlFuncUI,
                                type: "number",
                                min: 0,
                                max: 2500
                              },
                              domProps: { value: _vm.outputDurationValue },
                              on: {
                                blur: _vm.onOutputDurationChange,
                                input: function($event) {
                                  if ($event.target.composing) return
                                  _vm.outputDurationValue = $event.target.value
                                }
                              }
                            }),
                            false
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "title",
                                    style: {
                                      color: _vm.disabledCtrlFuncUI
                                        ? "#ddd"
                                        : "#6649C4",
                                      marginTop: "10px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Temperature Ctrl\n              "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            false
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.tempCtrlValue,
                                      expression: "tempCtrlValue"
                                    }
                                  ],
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: {
                                    disabled: _vm.disabledCtrlFuncUI,
                                    type: "number",
                                    min: 0,
                                    max: 255
                                  },
                                  domProps: { value: _vm.tempCtrlValue },
                                  on: {
                                    blur: _vm.onTemperatureOutputValueChange,
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.tempCtrlValue = $event.target.value
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      : _vm.supportCustomXYZModeOutputDuration &&
                        [0, 0x10, 0x20].includes(_vm.outputType)
                      ? _c(
                          "div",
                          { staticClass: "output-setting" },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                "\n                Output Settings\n              "
                              )
                            ]),
                            _c(
                              "van-radio-group",
                              {
                                attrs: { direction: "horizontal" },
                                on: { change: _vm.onOutputSettingChange },
                                model: {
                                  value: _vm.outputSetting,
                                  callback: function($$v) {
                                    _vm.outputSetting = $$v
                                  },
                                  expression: "outputSetting"
                                }
                              },
                              [
                                _c(
                                  "van-radio",
                                  {
                                    attrs: {
                                      name: "1",
                                      "checked-color": "#6649C4"
                                    }
                                  },
                                  [_vm._v("X Mode")]
                                ),
                                _c(
                                  "van-radio",
                                  {
                                    attrs: {
                                      name: "2",
                                      "checked-color": "#6649C4"
                                    }
                                  },
                                  [_vm._v("Y Mode")]
                                ),
                                _c(
                                  "van-radio",
                                  {
                                    attrs: {
                                      name: "3",
                                      "checked-color": "#6649C4"
                                    }
                                  },
                                  [_vm._v("Z Mode")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              ])
            : _vm._e(),
          _vm.supportTripleCartridge && _vm.outputType === 0x40
            ? _c(
                "div",
                [
                  _c("TripleTemperatureSetting", {
                    model: {
                      value: _vm.modelList[0],
                      callback: function($$v) {
                        _vm.$set(_vm.modelList, 0, $$v)
                      },
                      expression: "modelList[0]"
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.isSupportSwitchMode && _vm.outputType === 0x40
                    ? _c("TemperatureSetting", {
                        staticStyle: { "margin-top": "12px" },
                        model: {
                          value: _vm.modelList[0],
                          callback: function($$v) {
                            _vm.$set(_vm.modelList, 0, $$v)
                          },
                          expression: "modelList[0]"
                        }
                      })
                    : _vm._e(),
                  _vm.outputType === 0x40 &&
                  _vm.supportDoubleCartridge &&
                  _vm.isSupportSwitchMode
                    ? _c("TemperatureSetting2", {
                        staticStyle: {
                          "margin-top": "12px",
                          "padding-bottom": "60px"
                        },
                        attrs: {
                          "double-cartridge-mode": _vm.supportDoubleCartridge
                        },
                        model: {
                          value: _vm.modelList[0],
                          callback: function($$v) {
                            _vm.$set(_vm.modelList, 0, $$v)
                          },
                          expression: "modelList[0]"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
        ])
      ]),
      _c("div", { staticClass: "footer" }, [
        _c("div", { staticClass: "footer-item" }, [
          _c("img", {
            staticClass: "footer-setting",
            attrs: { src: require("@/assets/icons/icon_footer_setting.png") },
            on: { click: _vm.onClickSettingsView }
          }),
          _c("img", {
            staticClass: "footer-upload",
            attrs: { src: require("@/assets/icons/icon_upload.png") },
            on: { click: _vm.onClickUpload }
          }),
          _c("img", {
            staticClass: "footer-history",
            attrs: { src: require("@/assets/icons/icon_history.png") },
            on: { click: _vm.onClickHistory }
          })
        ])
      ]),
      _c(
        "van-popup",
        {
          staticClass: "menu-popup",
          style: { height: "100%", width: "88%" },
          attrs: { position: "left", round: "" },
          model: {
            value: _vm.showMenuPopup,
            callback: function($$v) {
              _vm.showMenuPopup = $$v
            },
            expression: "showMenuPopup"
          }
        },
        [
          _c(
            "div",
            { staticClass: "menu-header" },
            [
              _c("van-icon", {
                staticClass: "menu-return",
                attrs: { name: "arrow-left", size: "25", color: "#ffffff" },
                on: {
                  click: function($event) {
                    return _vm.onClickMenuReturn()
                  }
                }
              }),
              _c("img", {
                attrs: {
                  src: require("@/assets/logo/logo_wave_writer.png"),
                  alt: ""
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "menu-content" }, [
            _c("div", { staticClass: "menu-footer" }, [
              _c("span", { staticClass: "menu-footer-left" }, [
                _vm._v("V 1.0.11")
              ]),
              _c(
                "span",
                {
                  staticClass: "menu-footer-right",
                  on: { click: _vm.onClickSignOut }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/icons/icon_sign_out.png"),
                      alt: ""
                    }
                  }),
                  _vm._v("Sign out")
                ]
              )
            ])
          ])
        ]
      ),
      _c(
        "van-popup",
        {
          staticClass: "bluetooth-popup",
          style: { width: "88%" },
          attrs: { round: "" },
          model: {
            value: _vm.showBluetoothPopup,
            callback: function($$v) {
              _vm.showBluetoothPopup = $$v
            },
            expression: "showBluetoothPopup"
          }
        },
        [
          _c("div", { staticClass: "bluetooth-header" }, [
            _vm._v("Connect Device")
          ]),
          _c(
            "div",
            { staticClass: "bluetooth-content" },
            [
              _c(
                "van-loading",
                {
                  attrs: { color: "#6649C4", size: "40", "text-size": "16px" }
                },
                [_vm._v(_vm._s(_vm.bluetoothPopupMsg) + "\n      ")]
              ),
              _c(
                "div",
                { staticClass: "bluetooth-list" },
                _vm._l(_vm.deviceList, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "bluetooth-item" },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icons/icon_bluetooth_device.png")
                        }
                      }),
                      _vm._v(
                        "\n          " + _vm._s(item.name) + "\n          "
                      ),
                      _c(
                        "van-button",
                        {
                          staticClass: "bluetooth-connect-button",
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              return _vm.onClickConnectDevice(item)
                            }
                          }
                        },
                        [_vm._v("Connect\n          ")]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        ]
      ),
      _c(
        "van-popup",
        {
          staticClass: "save-popup",
          style: { width: "88%" },
          attrs: { round: "", "close-on-click-overlay": false },
          model: {
            value: _vm.showDisconnectPopup,
            callback: function($$v) {
              _vm.showDisconnectPopup = $$v
            },
            expression: "showDisconnectPopup"
          }
        },
        [
          _c("div", { staticClass: "save-header" }, [_vm._v("Tips")]),
          _c("div", { staticClass: "save-content" }, [
            _c("div", { staticClass: "save-content-msg" }, [
              _vm._v("\n        Are you sure to disconnect?\n      ")
            ]),
            _c("div", { staticClass: "save-footer" }, [
              _c(
                "button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "save-footer-cancel",
                  on: { click: _vm.onClickDisconnectCancel }
                },
                [_vm._v("\n          Cancel\n        ")]
              ),
              _c(
                "button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "save-footer-sure",
                  on: { click: _vm.onClickDisconnectSure }
                },
                [_vm._v("\n          Sure\n        ")]
              )
            ])
          ])
        ]
      ),
      _c(
        "van-popup",
        {
          staticClass: "save-popup",
          style: { width: "88%" },
          attrs: { round: "", "close-on-click-overlay": false },
          model: {
            value: _vm.showSavePopup,
            callback: function($$v) {
              _vm.showSavePopup = $$v
            },
            expression: "showSavePopup"
          }
        },
        [
          _c("div", { staticClass: "save-header" }, [_vm._v("Tips")]),
          _c("div", { staticClass: "save-content" }, [
            _c("div", { staticClass: "save-content-msg" }, [
              _vm._v("\n        Are you sure save the settings?\n      ")
            ]),
            _c("div", { staticClass: "save-footer" }, [
              _c(
                "button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "save-footer-cancel",
                  on: { click: _vm.onClickSaveCancel }
                },
                [_vm._v("\n          Cancel\n        ")]
              ),
              _c(
                "button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "save-footer-sure",
                  on: { click: _vm.onClickSaveSure }
                },
                [_vm._v("\n          Sure\n        ")]
              )
            ])
          ])
        ]
      ),
      _c(
        "van-popup",
        {
          staticClass: "save-popup",
          style: { width: "88%" },
          attrs: { round: "", "close-on-click-overlay": false },
          model: {
            value: _vm.showLogoutPopup,
            callback: function($$v) {
              _vm.showLogoutPopup = $$v
            },
            expression: "showLogoutPopup"
          }
        },
        [
          _c("div", { staticClass: "save-header" }, [_vm._v("Tips")]),
          _c("div", { staticClass: "save-content" }, [
            _c("div", { staticClass: "save-content-msg" }, [
              _vm._v("\n        Are you sure you want to log out?\n      ")
            ]),
            _c("div", { staticClass: "save-footer" }, [
              _c(
                "button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "save-footer-cancel",
                  on: {
                    click: function($event) {
                      return _vm.onClickLogout(false)
                    }
                  }
                },
                [_vm._v("\n          Cancel\n        ")]
              ),
              _c(
                "button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "save-footer-sure",
                  on: {
                    click: function($event) {
                      return _vm.onClickLogout(true)
                    }
                  }
                },
                [_vm._v("\n          Sure\n        ")]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "times-item-msg" }, [
      _c("div", { staticClass: "times-left" }, [_vm._v("1 s")]),
      _c("div", { staticClass: "times-right" }, [_vm._v("20 s")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "voltage-item-msg" }, [
      _c("div", { staticClass: "voltage-left" }, [_vm._v("0.1 v")]),
      _c("div", { staticClass: "voltage-right" }, [_vm._v("4.2 v")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }